var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('youtube',{ref:"youtube",staticStyle:{"width":"100%","height":"100%","padding":"10px"},attrs:{"player-vars":_vm.playerVars,"video-id":_vm.srcVideo},on:{"playing":_vm.playing,"ended":_vm.ended}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }